import React, { Component } from 'react';
import Text from '@lightspeed/cirrus-text';

class Uploading extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLooping: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.show) {
      setTimeout(() => {
        this.setState({
          isLooping: true,
        });
      }, 2600);
    }
  }

  render() {
    const { isLooping } = this.state;
    const { show } = this.props;

    return (
      <div style={{ display: show ? 'block' : 'none' }}>
        <div>
          <img
            src="https://d2o5po5b88zacb.cloudfront.net/dist/assets/lshash-9919532/images/ecom/launch3_sm.gif"
            width="400"
            height="322"
            style={{ display: !isLooping ? 'inline-block' : 'none' }}
            alt="eCom provisioning uploading"
          />
          <img
            src="https://d2o5po5b88zacb.cloudfront.net/dist/assets/lshash-9919532/images/ecom/launch3_loop_sm.gif"
            width="400"
            height="322"
            style={{ display: isLooping ? 'inline-block' : 'none' }}
            alt="eCom provisioning uploading"
          />
        </div>
        <Text body bold className="cr-text-center">
          Adding the finishing touches...
        </Text>
      </div>
    );
  }
}

export default Uploading;
